import { useInfiniteQuery } from '@tanstack/react-query';
import { LAMBDA_FORMS } from './constants';
import authenticatedApi from './authenticatedApi';

export const getPublog = async (
  lastEvaluatedKey = null,
  endDate: string
): Promise<{ result: any[]; lastEvaluatedKey: any }> => {
  const params = {
    lastEvaluatedKey: lastEvaluatedKey ? JSON.stringify(lastEvaluatedKey) : undefined,
    endDate,
  };

  const queryString = (Object.keys(params) as ('lastEvaluatedKey' | 'endDate')[])
    .map((key) =>
      params[key] ? `${encodeURIComponent(key)}=${encodeURIComponent(params?.[key] || '')}` : ''
    )
    .filter(Boolean)
    .join('&');

  const result: any = await authenticatedApi.get(`${LAMBDA_FORMS}/publog?${queryString}`);

  return {
    result: result.data,
    lastEvaluatedKey: result.lastEvaluatedKey,
  };
};

export const useGetPublog = (endDate: string) => {
  return useInfiniteQuery({
    queryKey: ['publog', endDate],
    queryFn: ({ pageParam = null }) => getPublog(pageParam, endDate),
    getNextPageParam: (lastPage) => {
      return lastPage.lastEvaluatedKey || undefined;
    },
    initialPageParam: null,
    staleTime: 30000,
    retry: false,
  });
};
